<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-input-number
      :size="size"
      :min="min"
      :max="max"
      :step="step"
      v-decorator="[varName, { 
                    rules: [{ required: varRequired, message: message}],
                    initialValue: varInitial
                    }]"
      :placeholder="varLabel"
    />
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: Number,
    varRequired: Boolean,
    formLayout: String,
    size: String,
    description: [String, null],
    max: [Number, null],
    min: [Number, null],
    step: {
      type: Number,
      default: 1
    }
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()} as integer between ${this.max} and ${this.min}`;
    }
  }
};
</script>
